import { ExceptionIgnoreScope } from '../../../../shared/issuesV2';
import { IssueResolutionScope } from '../../../../typings/enums';
import * as permissions from '../../../helpers/permissions';
import type { IssueExceptionsForDashboard } from '../../../../shared/issuesV2';
import type { PolicyType } from '../../../types';

export const canRemoveException = (exception: IssueExceptionsForDashboard): boolean => {
  switch (exception.ignoreScope) {
    case ExceptionIgnoreScope.Project: {
      if (!exception.exceptionUserProjectId) {
        return false;
      }
      return permissions.userHasPermissionToResolveIssueByCategory(
        exception.issueCategory,
        {
          scope: IssueResolutionScope.Project,
          projectId: exception.exceptionUserProjectId,
        },
      );
    }
    case ExceptionIgnoreScope.ReleaseGroup: {
      if (!exception.exceptionUserReleaseGroupId) {
        return false;
      }
      return permissions.userHasPermissionToResolveIssueByCategory(
        exception.issueCategory,
        {
          scope: IssueResolutionScope.ReleaseGroup,
          releaseGroupId: exception.exceptionUserReleaseGroupId,
        },
      );
    }
    case ExceptionIgnoreScope.ProjectAndReleaseGroups: {
      if (!exception.exceptionUserProjectId) {
        return false;
      }

      const hasProjectPermission = permissions.userHasPermissionToResolveIssueByCategory(
        exception.issueCategory,
        {
          scope: IssueResolutionScope.Project,
          projectId: exception.exceptionUserProjectId,
        },
      );

      return (
        hasProjectPermission &&
        permissions.userHasPermissionToResolveAnyRg(exception.issueCategory)
      );
    }
    case ExceptionIgnoreScope.Policy: {
      if (!exception.exceptionUserPolicyId) {
        return false;
      }

      return permissions.userHasPermissionToCreatePolicyType(exception.issueCategory.toUpperCase() as PolicyType);
    }
    case ExceptionIgnoreScope.Organization: {
      return permissions.userHasPermissionToResolveIssueAnyProjectAndRg(
        exception.issueCategory,
      );
    }
    default:
      return false;
  }
};
